module.exports = __webpack_public_path__ + "static/img/fullscreen-image_our-awards_768.8fc30cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/fullscreen-image_our-awards_768.png
// module id = L8bc
// module chunks = 0